export enum RoutePaths {
  root = '/',
  login = '/login',
  verifyEmail = '/verify-email',
  requestPasswordReset = '/request-password-reset',
  resetPassword = '/reset-password',
  dashboard = '/dashboard',
  pictures = '/pictures',
  guests = '/guests',
  guestsTable = '/guests/table',
  admin = '/admin',
  download = '/download',
  calculators = '/calculators',
  calculatorsPage = '/calculators/:id',
  settings = '/settings',
}
